/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Txn } from '@src/app/model/txn';
import { AbstractPageComponent } from '@src/app/shared/form/abstract-page.component';
import { FieldSet } from '@src/app/shared/form/field-set/field-set.component';
import { FormConfig } from "@src/app/shared/form/FormConfig";
import { BCodeService } from '@src/app/modules/budget/bcode.service';
import { FormPageComponent } from '@src/app/shared/form/form-page/form-page.component';
import { ApDetailTxnService } from '@src/app/modules/txn/ap-detail-txn.service';
import { CycleService } from '@src/app/modules/budget/cycle.service';
import { ApDetailPageNavRoute } from '@src/app/routes/ap-detail-page.nav';

@Component({
    selector: 'app-ap-page',
    templateUrl: './ap-detail-page.component.html',
    styleUrls: ['./ap-detail-page.component.scss'],
    imports: [FormPageComponent]
})
export class ApDetailPageComponent extends AbstractPageComponent {
    dataSvc = inject(ApDetailTxnService);
    bCodeSvc = inject(BCodeService);
    protected cycleSvc = inject(CycleService);
    protected activeRoute = inject(ActivatedRoute);


    readonly path = Txn.LEDGER.AP.code;

    config = new FormConfig({
        navRoute: ApDetailPageNavRoute,
        docPath: 'omc-books/purchase-accounting/purchase-detail',
        title: 'Purchase Detail Analysis',
        help: $localize`Accounts Payable Detail Transactions`,
        fieldSet: new FieldSet({
            fields: this.dataSvc.getFields(),
            formLayout: [
                { cells: [{ width: '25%' }, { width: '25%' }, { width: '25%' }, { width: '25%' }] },
                { cells: [{ colspan: 4, pageTab: 'yes' }] }
            ],
        }),
        service: this.dataSvc,
        mode: 'list',
        allowNew: false,
        pathEdit: (o: Txn) => Txn.getTxnLink(o),
        beforeList: this.beforeList.bind(this)
    });

    beforeList(data: { debit: number, credit: number, txnValue: number }[]) {
        data.forEach(t => t.txnValue = Math.round(((t.debit - t.credit) * 100) / 100));
        return data;
    }
}
